import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export interface ConferenceSpeaker {
    id: number;
    period_id: number;
    conference_id: number | null;
    certificate_type_id?: number | null;
    name: string;
    email?: string | null;
    topic?: string | null;
    institution?: string | null;
    is_present: boolean;
    rooms?: { id: number; name: string }[];
    created_at?: string;
    updated_at?: string;
}

export const useAdminConferenceSpeakers = (periodId?: string, conferenceId?: string) => {
    return useQuery({
        queryKey: ["admin-conference-speakers", periodId, conferenceId],
        queryFn: async () => {
            const params: any = {};
            if (periodId && periodId !== "all") params.period_id = periodId;
            if (conferenceId && conferenceId !== "all") params.conference_id = conferenceId;
            const { data } = await axiosClient.get("/private/conference-speakers", { params });
            return data.data as ConferenceSpeaker[];
        },
    });
};

export const useCreateConferenceSpeaker = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: Partial<ConferenceSpeaker>) => {
            const { data } = await axiosClient.post("/private/conference-speakers", payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-conference-speakers"] });
        },
    });
};

export const useUpdateConferenceSpeaker = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, payload }: { id: number; payload: Partial<ConferenceSpeaker> }) => {
            const { data } = await axiosClient.put(`/private/conference-speakers/${id}`, payload);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-conference-speakers"] });
        },
    });
};

export const useDeleteConferenceSpeaker = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: number) => {
            const { data } = await axiosClient.delete(`/private/conference-speakers/${id}`);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-conference-speakers"] });
        },
    });
};

